import { Alert, Card, CardContent, CardTitle, IconButton, Stack } from "@altimateai/lego";
import { Cell, Pie, TooltipProps } from "recharts";
import classes from "../summary.module.scss";
import { OverallSavingsResponse } from "../context/types";
import { InfoIcon } from "@/assets/icons";
import { Chart, ChartTypes } from "@/uiCore";
import SavingsPieTooltip, { SAVINGS_PIE_COLORS } from "./SavingsPieTooltip";

const SavingsInFuture = ({ data }: { data?: OverallSavingsResponse }) => {
  const graphData = data
    ? [
        {
          name: "total_autonomous_savings",
          label: "Autonomous",
          value: data.total_autonomous_savings,
        },
        {
          name: "total_assisted_savings",
          label: "Assisted",
          value: data.total_assisted_savings,
        },
      ]
    : [];

  if (!data) {
    return <Alert>No data available</Alert>;
  }

  return (
    <Stack>
      <Card style={{ padding: "1rem", flex: 1, maxWidth: "50%" }}>
        <CardTitle>
          <Stack justify="between" align="center">
            Money Savings Per Month
            <IconButton variant="ghost" title="Projected money savings per month">
              <InfoIcon />
            </IconButton>
          </Stack>
        </CardTitle>
        <CardContent>
          <Chart
            type={ChartTypes.PieChart}
            data={graphData}
            xAxisDataKey="name"
            title="Money Savings"
            hideFullscreenButton
            height={350}
            tooltipProps={{
              content: (props: TooltipProps<number, string>) => (
                <SavingsPieTooltip
                  {...props}
                  data={{
                    total: data.total_savings,
                    autonomous: data.total_autonomous_savings,
                    assisted: data.total_assisted_savings,
                  }}
                />
              ),
            }}
          >
            {() => (
              <Pie dataKey="value" data={graphData} fill="#247EFE">
                {graphData.map((_entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={SAVINGS_PIE_COLORS[index % SAVINGS_PIE_COLORS.length]}
                    name={_entry.label}
                  />
                ))}
              </Pie>
            )}
          </Chart>
        </CardContent>
      </Card>
      <Card className={classes.donutChart} style={{ flex: 1, maxWidth: "50%" }}>
        <CardTitle>
          <Stack justify="between" align="center">
            Time Savings Per Month
            <IconButton variant="ghost" title="Projected time savings per month">
              <InfoIcon />
            </IconButton>
          </Stack>
        </CardTitle>
        <CardContent className="al-mt-12">
          <div className={classes.donut}>{data.time_saved}</div>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default SavingsInFuture;
